// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import { useEffect } from 'react';
import SoundManager from '../utils/system/SoundManager';
import SoundEffects from '../utils/system/SoundEffects';
import EventBus, { EVENT_TYPES } from '../utils/system/EventBus';

/**
 * Handles audio initialization on first user interaction and
 * ambient sound management based on orbit state.
 */
export function useAudioInit() {
  useEffect(() => {
    const initializeAudio = () => {
      SoundManager.initialize();
      SoundEffects.initialize();
      SoundEffects.play('engine_hum', { loop: true, volume: 0.15 });
      SoundEffects.play('bridge_ambient', { loop: true, volume: 0.08 });
      document.removeEventListener('click', initializeAudio);
      document.removeEventListener('keydown', initializeAudio);
    };

    document.addEventListener('click', initializeAudio);
    document.addEventListener('keydown', initializeAudio);

    return () => {
      document.removeEventListener('click', initializeAudio);
      document.removeEventListener('keydown', initializeAudio);
      SoundEffects.stop('engine_hum');
      SoundEffects.stop('bridge_ambient');
    };
  }, []);

  useEffect(() => {
    const handleEnterOrbit = () => {
      SoundEffects.stop('engine_hum');
      SoundEffects.stop('bridge_ambient');
    };

    const handleExitOrbit = () => {
      SoundEffects.play('engine_hum', { loop: true, volume: 0.15 });
      SoundEffects.play('bridge_ambient', { loop: true, volume: 0.08 });
    };

    const unsubEnter = EventBus.on(EVENT_TYPES.ENTER_ORBIT, handleEnterOrbit);
    const unsubExit = EventBus.on(EVENT_TYPES.EXIT_ORBIT, handleExitOrbit);

    return () => {
      unsubEnter();
      unsubExit();
    };
  }, []);
}
